const Urls = {
	Templates: {
		app: '/my/api/2/templates?name=modules/customer-menu/app.html'
	}
};

if (window.ModulesTmpl && window.ModulesTmpl.customerMenu) {
	Urls.Templates = Object.assign(Urls.Templates, window.ModulesTmpl.customerMenu);
}

export default Urls;